import React from 'react';
import { Link } from 'react-router-dom';
import { environments } from 'environments/environments';
import { Video } from '../Video.interface';
import imagePlaceholder from 'assets/img/DT_bubak.png';
import './SingleVideo.css';

const SingleVideo = (props: { video: Video }) => {
  const video = props.video;
  const date = new Date(video.recordTime || 0)
  const renderDate = `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()}`
  const image = video.image
    ? video.image.includes('http')
      ? video.image
      : environments.server + video.image
    : imagePlaceholder;
  return (
    <div className="video-card">
      <a href={video.link} target="_blank" rel="noopener noreferrer">
        <img className="video-image" src={image} alt={video.name || 'Video náhled'} />
      </a>
      <div className="video-details">
        <p className="video-name">
          <a href={video.link} target="_blank" rel="noopener noreferrer">
            {video.name || "Video"}
          </a>
        </p>
        <div className="video-info-line">
          <ul className="video-info-list">
            {video.author
              ? <li>{video.author}</li>
              : null}
            {video.duration
              ? <li>{video.duration}</li>
              : null}
            {video.recordTime
              ? <li>{renderDate}</li>
              : null}
          </ul>
        </div>
        {video.description
          ? <p className="description">{video.description}</p>
          : null}
        {video.embed
          ? <p className="video-play"><Link to={`/videa/${video.embed}`}>Přehrát zde</Link></p>
          : null}
      </div>
    </div>
  )
}

export default SingleVideo